/**
 * @generated SignedSource<<6de0931b5addc2474980d132240432d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ExportInvoiceQuickbooksInput = {
  invoiceId?: string | null;
  customerId?: string | null;
  taxCodeId?: string | null;
  blankReference?: boolean | null;
  exportNames?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type exportInvoiceQuickbooksMutation$variables = {
  input: ExportInvoiceQuickbooksInput;
};
export type exportInvoiceQuickbooksMutation$data = {
  readonly exportInvoiceQuickbooks: {
    readonly invoice: {
      readonly quickbooksId: number | null;
    } | null;
  } | null;
};
export type exportInvoiceQuickbooksMutation = {
  variables: exportInvoiceQuickbooksMutation$variables;
  response: exportInvoiceQuickbooksMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quickbooksId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "exportInvoiceQuickbooksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExportInvoiceQuickbooksPayload",
        "kind": "LinkedField",
        "name": "exportInvoiceQuickbooks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceType",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "exportInvoiceQuickbooksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExportInvoiceQuickbooksPayload",
        "kind": "LinkedField",
        "name": "exportInvoiceQuickbooks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceType",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "46126b0ffb2fe88dadb385e8b0e18402",
    "id": null,
    "metadata": {},
    "name": "exportInvoiceQuickbooksMutation",
    "operationKind": "mutation",
    "text": "mutation exportInvoiceQuickbooksMutation(\n  $input: ExportInvoiceQuickbooksInput!\n) {\n  exportInvoiceQuickbooks(input: $input) {\n    invoice {\n      quickbooksId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b78709a00ab67efb92c01a72f52fb991";

export default node;
